var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { useBackgroundContext } from '../BackgroundContext/index.js';
export const Label = props => {
    const { children, className, secondaryLabel, tertiaryLabel } = props, rest = __rest(props, ["children", "className", "secondaryLabel", "tertiaryLabel"]);
    const { backgroundType } = useBackgroundContext();
    const textClsx = [
        backgroundType === 'main' && 'text-content-on-background',
        backgroundType === 'surface' && 'text-content',
        backgroundType === 'secondary' && 'text-content-on-topbar',
    ];
    const label = (React.createElement("label", Object.assign({ className: clsx('block font-medium', textClsx, className) }, rest), children));
    if (!!secondaryLabel || !!tertiaryLabel) {
        return (React.createElement("div", { className: "flex space-s-2 items-center justify-between" },
            !secondaryLabel ? (label) : (React.createElement("div", { className: "flex space-s-1 items-center" },
                label,
                React.createElement("div", null, secondaryLabel))),
            React.createElement("div", null, tertiaryLabel)));
    }
    return label;
};
//# sourceMappingURL=Label.js.map